import { BATCH_DELAY, HISTORY_LIMIT } from "./constants";

export class HistoryManager {
  constructor(editor) {
    this.editor = editor;
    this.current = null
    this.undoStack = [];
    this.redoStack = [];

    this.isRestoring = false;

    this.transactionDepth = 0;
    this.pendingSnapshot = null;

    this.batchTimeout = null;
    this.lastDocHash = null;
  }

  // ---------------- INIT ----------------

  init(snapshot) {
    this.undoStack = [snapshot];
    this.redoStack = [];

    this.lastDocHash = this.hashDoc(snapshot.doc);

    this.current = snapshot
    this.editor.selection.setAtEnd();
    this.emitChange();
  }

  reinit({ html }) {
    const snapshot = this.editor.createSnapshotFromHTML({ html });
    this.init(snapshot);

    if (this.batchTimeout) {
      clearTimeout(this.batchTimeout);
      this.batchTimeout = null;
    }

    this.current = snapshot
    this.pendingSnapshot = null;
  }

  push(snapshot) {
    if (this.isRestoring) return;

    const docHash = this.hashDoc(snapshot.doc);

    if (docHash === this.lastDocHash) return;

    this.undoStack.push(snapshot);

    if (this.undoStack.length > HISTORY_LIMIT) {
      this.undoStack.shift();
    }

    this.redoStack = []; // clear redo when new change

    this.lastDocHash = docHash;
    this.current = snapshot
    this.emitChange();

  }

  undo() {
    if (this.undoStack.length <= 1) return;

    const current = this.undoStack.pop();
    this.redoStack.push(current);
    console.log({ current });

    const snapshot = this.peekUndo();

    this.restore(snapshot);
    this.current = snapshot
    this.lastDocHash = this.hashDoc(snapshot.doc);
  }

  redo() {
    if (!this.redoStack.length) return;

    const snapshot = this.redoStack.pop();
    console.log({ current: snapshot });

    this.undoStack.push(snapshot);

    this.restore(snapshot);
    this.current = snapshot
    this.lastDocHash = this.hashDoc(snapshot.doc);
  }

  peekUndo() {
    return this.undoStack[this.undoStack.length - 1];
  }

  restore(snapshot) {
    this.isRestoring = true;

    this.editor.restoreSnapshot(snapshot);

    this.isRestoring = false;

    this.emitChange();
  }

  startTransaction() {
    this.transactionDepth++;
  }

  endTransaction() {
    if (this.transactionDepth === 0) return;

    this.transactionDepth--;

    if (this.transactionDepth === 0 && this.pendingSnapshot) {
      this.push(this.pendingSnapshot);
      this.pendingSnapshot = null;
    }
  }

  scheduleSnapshot() {
    if (this.isRestoring) return;

    if (this.batchTimeout) {
      clearTimeout(this.batchTimeout);
    }

    this.batchTimeout = window.setTimeout(() => {
      const snapshot = this.editor.updateSnapshot();

      if (this.transactionDepth > 0) {
        this.pendingSnapshot = snapshot;
      } else {
        this.push(snapshot);
      }
    }, BATCH_DELAY);
  }

  takeSnapshot() {
    if (this.isRestoring) return;

    if (this.batchTimeout) {
      clearTimeout(this.batchTimeout);
      this.batchTimeout = null;
    }

    const snapshot = this.editor.createSnapshot();
    this.push(snapshot);
  }

  hashDoc(doc) {
    return JSON.stringify(doc);
  }

  emitChange() {
    window.dispatchEvent(new CustomEvent("editor-history-change"));
  }
  canUndo() {
    return this.undoStack.length > 1;
  }

  canRedo() {
    return this.redoStack.length > 0;
  }

  clear() {
    this.undoStack = [];
    this.redoStack = [];
    this.lastDocHash = null;
  }
}